import { makeStyles } from '@material-ui/core';
import React from 'react';
import { FlexBox } from '../Flex/FlexBox';
import { PageInfo } from './components/PageInfo';
import { PageSizeSelect } from './components/PageSizeSelect';
import { Paginator } from './components/Paginator';
var useStyles = makeStyles(function (theme) {
    var _a, _b;
    return ({
        wrapper: (_a = {
                padding: theme.spacing(2.5, 1.5),
                boxSizing: 'border-box',
                position: 'relative',
                display: 'grid',
                rowGap: theme.spacing(1.5) + "px",
                gridTemplateAreas: '"select  paginator info"'
            },
            _a[theme.breakpoints.down('sm')] = {
                gridTemplateAreas: "\n        \"paginator\"\n        \"info\"\n        \"select\"\n      ",
            },
            _a),
        select: {
            gridArea: 'select',
        },
        paginator: {
            gridArea: 'paginator',
            justifyContent: 'center',
        },
        info: {
            gridArea: 'info',
            justifyContent: 'flex-end',
        },
        section: (_b = {
                color: theme.palette.text.primary,
                display: 'flex',
                alignItems: 'center',
                fontSize: 14,
                userSelect: 'none'
            },
            _b[theme.breakpoints.down('sm')] = {
                justifyContent: 'center',
            },
            _b),
    });
});
export var Pagination = function (_a) {
    var count = _a.count, currentPage = _a.currentPage, itemsPerPage = _a.itemsPerPage, onChangeItemsPerPage = _a.onChangeItemsPerPage, onLoadPage = _a.onLoadPage, onLoadPreviousPage = _a.onLoadPreviousPage, onLoadNextPage = _a.onLoadNextPage, pageCount = _a.pageCount, pageSizeOptions = _a.pageSizeOptions;
    var styles = useStyles();
    return (React.createElement(FlexBox, { className: styles.wrapper },
        React.createElement("div", { className: styles.section + " " + styles.select },
            React.createElement(PageSizeSelect, { onChange: onChangeItemsPerPage, options: pageSizeOptions, value: itemsPerPage })),
        React.createElement("div", { className: styles.section + " " + styles.paginator },
            React.createElement(Paginator, { currentPage: currentPage, onChange: function (nextPage) {
                    if (nextPage === currentPage - 1) {
                        onLoadPreviousPage();
                    }
                    if (nextPage === currentPage + 1) {
                        onLoadNextPage();
                    }
                    onLoadPage(nextPage);
                }, pageCount: pageCount })),
        React.createElement("div", { className: styles.section + " " + styles.info, "data-name": "pagination-item-count" },
            React.createElement(PageInfo, { count: count, currentPage: currentPage, itemsPerPage: itemsPerPage, pageCount: pageCount }))));
};
//# sourceMappingURL=Pagination.js.map